import { render, staticRenderFns } from "./AccountReports.vue?vue&type=template&id=62071d6e&"
import script from "./AccountReports.vue?vue&type=script&lang=js&"
export * from "./AccountReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62071d6e')) {
      api.createRecord('62071d6e', component.options)
    } else {
      api.reload('62071d6e', component.options)
    }
    module.hot.accept("./AccountReports.vue?vue&type=template&id=62071d6e&", function () {
      api.rerender('62071d6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/account/components/AccountReports.vue"
export default component.exports